import React, { Fragment } from "react";
import useWindowSize from '../../hooks/useWindowSize';
import Carousel from "react-multi-carousel";
import ContentSliderItem from "../../components/drawer-slider-item/drawer-slider-item";
import "./drawer.css";

const ContentSlider = (props) => {
  const screenStatus = useWindowSize()
  const drawerType = props.drawerType
  const dataArr = props.contentSliderDataArr
  //console.log(dataArr)
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    laptop: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2.5,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 320 },
      items: 1.4,
      slidesToSlide: 1, // optional, default to 1.
      //partialVisibilityGutter: 100
    },
    mobileS: {
      breakpoint: { max: 375, min: 280 },
      items: 1.3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobileXS: {
      breakpoint: { max: 280, min: 0 },
      items: 1.2,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const responsiveLandscapeType = {
    desktop: {
      breakpoint: { max: 3000, min: 1200 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    laptopL: {
      breakpoint: { max: 1200, min: 1024 },
      items: 2.5,
      slidesToSlide: 1, // optional, default to 1.
    },
    laptop: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 768, min: 670 },
      items: 1.8,
      slidesToSlide: 1, // optional, default to 1.
    },
    tabletS: {
      breakpoint: { max: 670, min: 550 },
      items: 1.5,
      slidesToSlide: 1, // optional, default to 1.
    },
    tabletXS: {
      breakpoint: { max: 550, min: 425 },
      items: 1.2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 425, min: 375},
      items: 1.1,
      slidesToSlide: 1, // optional, default to 1.
      //partialVisibilityGutter: 100
    },
    mobileS: {
      breakpoint: { max: 375, min: 320},
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
      //partialVisibilityGutter: 100
    },
    mobileXS: {
      breakpoint: { max: 320, min: 0},
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
      //partialVisibilityGutter: 100
    }
  };
 
  //Center mode modification
  const numberOfSliders = dataArr.length
  //console.log(numberOfSliders)
  let cssModifier = false
  if(numberOfSliders < 4 && screenStatus === 'desktop'){
    cssModifier = true
  }else if(numberOfSliders < 3 && screenStatus === 'laptop'){
    cssModifier = true
  }else if(numberOfSliders < 3 && screenStatus === 'tablet'){
    cssModifier = true
  }
  //console.log(cssModifier)
  let responsiveSetting = responsive
  drawerType === 'landscape' || drawerType === 'landscapeside' ? responsiveSetting = responsiveLandscapeType : responsiveSetting = responsive
  return (
    <Fragment>
      <Carousel
        swipeable={true}
        draggable={true}
        showDots={false}
        responsive={responsiveSetting}
        ssr={true} // means to render carousel on server-side.
        infinite={false}
        //autoPlay={this.props.deviceType !== "mobile" ? true : false}
        //autoPlaySpeed={1000}
        keyBoardControl={true}
        customTransition="transform 1000ms cubic-bezier(0.165, 0.84, 0.44, 1) 100ms"
        //transitionDuration={500}
        //containerClass="carousel-container"
        removeArrowOnDeviceType={["mobile","tablet","tabletS","tabletXS","mobileS","mobileXS"]}
        //deviceType={this.props.deviceType}
        //dotListClass="custom-dot-list-style"
        //itemClass="carousel-item-padding-40-px"
        focusOnSelect={false}
        //minimumTouchDrag={150}
        //partialVisible={true}
        containerClass={`${cssModifier ? "react-multi-carousel-list-modifier" : null}`}
      >
       {dataArr.map(slideInfo => {
                return <ContentSliderItem
                    key={slideInfo.id}
                    imageUrl={slideInfo.imageUrl}
                    mobileImageUrl={slideInfo.mobileImageUrl}
                    imageAlt={slideInfo.imageAlt}
                    redirectURL={slideInfo.redirectURL}
                    description = {slideInfo.description}
                    position={slideInfo.id}
                    drawerTypeTagging = "Bottom"
                    drawerType={drawerType}
                />
            })}
      </Carousel>
    </Fragment>
  );
};
export default React.memo(ContentSlider);
